import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle} from './puzzle.js';
import {BoardObject} from './board-object.js';

export class SpecialPower extends Component {
    static TypeName = 'special-power';

    @property.bool(false)
    bloatParent = false;

    @property.bool(false)
    canBeEjected = false;

    @property.bool(false)
    hideEyes = false;

    @property.bool(false)
    closEyes = false;

    init() {
        this.active = false;
    }

    start() {}

    update(dt: number) {}

    activate(puzzle: Puzzle, row: number, column: number) {
        // if (clickOnFX && QualityControlManager.GetInstance().Quality != QualityControlManager.DeviceQuality.VeryLow)
        //     {
        //         Instantiate(clickOnFX, transform.position, puzzle.Lanes[column].transform.rotation);
        //     }

        // default object just starts a chain reaction.
        puzzle.explode(row, column);
    }

    /**
     * @virtual
     */
    popped(puzzle: Puzzle, row: number, column: number) {}

    /**
     * called when this object is loaded into another
     * @virtual
     */
    loaded(newParent: BoardObject) {}

    /**
     * called when this object is placed on the board.
     * @virtual
     */
    placed(puzzle: Puzzle, newParent: BoardObject) {}

    /**
     * called when this object explodes on the board.
     * @virtual
     */
    explode(puzzle: Puzzle, row: number, column: number) {}
}
